<template>
  <div class="v2_71">

    <!-- TOP HEADER -->
    <div class="v2_137">
      <div class="upi-brand">
        <img :src="'upilogo.png'" />
        <div class="upi-divider"></div>
        <div class="upi-text">
          <div>Secure. Simple. Instant.</div>
          <span>Fast and safe payments through UPI</span>
        </div>
      </div>
    </div>

    <!-- WALLET MESSAGE -->
    <div class="wallet-message">
      <span>✓</span>
      Your payment amount will be added to your wallet
    </div>

    <!-- MAIN PAYMENT BOX -->
    <div class="v2_74">

      <!-- QR + AMOUNT -->
      <div class="v2_131">
        <span class="v2_132">Use Mobile Scan code to pay</span>
      </div>

      <div class="v2_133">
        <span class="v2_134">₹{{ userammount }}</span>
      </div>

      <div class="v2_135">
        <span class="v2_136">{{ uniquePaymentId }}</span>
      </div>

      <!-- QR Section -->
      <div class="v2_122">
        <div class="v2_123"></div>

        <div class="v2_126">
          <div class="v2_127" @click="saveQrCode">
            <div class="v2_128"></div>
            <span class="v2_129">Save QRCode</span>
          </div>
          <div class="v2_130">
               <img :src="Qrcode"
            style="width: 170px; height: 190px; padding: 10px 0px;" />
          </div>

        </div>



        
      </div>

        <!-- COPY UPI SECTION -->
      <div class="v2_92">
        <span class="v2_109">UPI ID</span>

        <div class="v2_103">
          <span id="upi" class="v2_108">{{ UPIID }}</span>

          <div class="v2_105" @click="onCopy">
            <span class="v2_107">Copy</span>
          </div>

        </div>

        <div class="qr-info">
          <span class="qr-check">✓</span>
          <span>
            Scan this QR code using any UPI app and complete the payment. After successful payment, enter your 12 digit UTR below.
          </span>
        </div>

        <span class="v2_102">
          Select your UPI app to complete payment
        </span>

        <div style="margin-top: 10px; margin-bottom: 10px; display: flex; justify-content: center;">

          <div class="v2_97">
            <img :src="'pytm.jpg'" style="width: 45px; height: 45px; " />
            <span>Paytm</span>
          </div>
          <div class="v2_98">
            <img :src="'payIcon_2.ff616d58.png'" style="width: 45px; height: 45px; " />
            <span>PhonePe</span>
          </div>
          <div class="v2_99">
            <img :src="'gpay.jpg'" style="width: 45px; height: 45px; " />
            <span>GPay</span>
          </div>
          <div class="v2_100">
            <img :src="'bhim.jpg'" style="width: 45px; height: 45px; " />
            <span>BHIM</span>
          </div>
          </div>
          <div class="upi-info-text">
            You will remain in this app. Payment will be completed in your UPI app.
          </div>



        <div class="v2_96"></div>
      </div>

      <!-- UTR INPUT -->
      <span class="v2_91">Enter 12 Digit UTR Number</span>

      

          <input type="text" id="upi-input" value="" name="channel_order" placeholder="Enter 12 digit UTR" maxlength="12" oninput="this.value=this.value.replace(/[^\d]/g,'')" onchange="this.value=this.value.replace(/[^\d]/g,'')"
          style="
    width: 100%;
    height: 50px;
    margin-bottom: 10px;
    background: #f5f5f7;
    text-align: center;
    line-height: 50px;
    font-weight: 700;
    border-radius: 30px;
    color: #333;
    font-size: 16px;
"
          >

      <!-- SUBMIT UTR BUTTON -->
      <div class="v2_83" @click="onSubmit">
        <div class="v2_84"></div>
        <div class="v2_85">
          <span class="v2_86">Verify & Submit</span>
        </div>
      </div>

      <!-- NOTICE BOX -->
      <div class="v2_77">
        <span class="v2_82">Notice</span>

        <div class="v2_78">
          <span class="v2_80">
            1. The payment amount must match the order amount; otherwise, the order will not be successful.
          </span>

          <span class="v2_81">
            2. Please select a payment method and make sure the wallet is installed before making payment.
          </span>

          <span class="v2_81">
            3. Please enter the UTR to speed up your order verification process.
          </span>

          <span class="v2_81">
            4. Once the UTR is submitted, your order will enter the verification process. Please avoid placing duplicate orders.
          </span>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <Modal v-model:visible="isNoticeModalVisible" height="auto" width="70%">
      <div style="background: #fff" class="modal-header">
        <h5 class="modal-title">NOTICE</h5>
        <button class="close" @click="isNoticeModalVisible = false; hideModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body py-0">
        <div class="sign-info logout-info" style="font-weight: bold;">
          <p>1. Do not save this UPI for next time. Always use latest account.</p>
          <p>2. Any loss due to wrong UPI is not platform responsibility.</p>
          <p>3. For queries, contact customer service.</p>
        </div>
      </div>

      <div class="modal-footer" style="justify-content:center;">
        <button class="btn btn-comman active payment-btn text-white"
                @click="isNoticeModalVisible = false; hideModal()">
          Submit ({{ countDown1 }}s)
        </button>
      </div>
    </Modal>

    <!-- TOAST -->
    <div class="toast-content" v-show="isErrorShow">
      <div class="toast-message">{{ errorMessage }}</div>
    </div>

  </div>
</template>


<script :src="'https://gateway.ekpays.com/static/assets/js/jquery-2.1.4.min.js'"></script>
<script>
import { useRouter } from "vue-router";
import axios from "axios";
import { ref, onMounted, onBeforeUnmount } from "vue";
import $ from "jquery";
import Footer from "../components/CommonFooter.vue";
import { Modal } from "usemodal-vue3";

export default {
  components: { Footer, Modal },

  props: {
    toggleLoader: { type: Function },
  },

  setup() {
    const router = useRouter();

    const isAppWebView = /wv|WebView|flutter/i.test(navigator.userAgent);

    const userammount = ref("");
    const UPIID = ref("");
    const Qrcode = ref("");

    const isErrorShow = ref(false);
    const errorMessage = ref("");

    const countDownMinute = ref(0);
    const countDownSecond = ref(0);
    const countDown = ref(1800);

    const countDown1 = ref(20);
    const isNoticeModalVisible = ref(false);

    let noticeInterval = null;
    let mainTimer = null;

    // ---------------------------
    // OPEN UPI PAYMENT
    // ---------------------------
    const openPayment = () => {

      if (isAppWebView) {
        setErrorMessage("Please use QR code payment");
        return;
      }

      const upiUrl = `upi://pay?pa=${UPIID.value}&pn=Payment&am=${userammount.value}&cu=INR`;

      window.location.href = upiUrl;
    };

    // ---------------------------
    // FETCH UPI FROM API
    // ---------------------------
    const getupiFun = async () => {
      axios
        .get("/get-upi")
        .then((response) => {
          UPIID.value = response.data.data.second_upi_id;
          Qrcode.value = response.data.data.second_qr_code;
        })
        .catch((error) => {
          console.log(error.data?.error);
        });
    };

    // ---------------------------
    // COPY UPI
    // ---------------------------
    const onCopy = async () => {
      try {
        const curl = $("#upi").html();
        await navigator.clipboard.writeText(curl);
        setErrorMessage("UPI copied successfully");
      } catch (e) {
        setErrorMessage("Copy failed, please input manually");
      }
    };

    // ---------------------------
    // ERROR TOAST
    // ---------------------------
    const setErrorMessage = (value) => {
      errorMessage.value = value;
      isErrorShow.value = true;

      setTimeout(() => {
        errorMessage.value = "";
        isErrorShow.value = false;
      }, 3000);
    };

    // ---------------------------
    // SUBMIT UTR
    // ---------------------------
    
// Save QR Code
const saveQrCode = async () => {
  try {
    if (!Qrcode.value) {
      setErrorMessage("QR Code not available");
      return;
    }

    const response = await fetch(Qrcode.value);
    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "QRCode.png";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    setErrorMessage("QR Code saved successfully");
  } catch (err) {
    console.error(err);
    setErrorMessage("Unable to save QR Code");
  }
};

const onSubmit = async () => {
      const utr = $("#upi-input").val();

      if (utr.length < 12) {
        return setErrorMessage("Invalid Ref Number");
      }

      axios
        .post("/recharge", {
          amount: userammount.value,
          rechargetype: "CSPay",
          reference: utr,
        })
        .then((response) => {
          if (response.data.success) {
            setErrorMessage(response.data.message);
            router.push("/recharge-status?st=success");
            // setTimeout(() => {
            //   router.push("/mine");
            // }, 2000);
          } else {
            setErrorMessage(response.data.message);
            router.push("/recharge-status?st=fa");
          }
        })
        .catch(() => {
          setErrorMessage("Server error. Try again.");
        });
    };

    // ---------------------------
    // MODAL BODY SCROLL CONTROL
    // ---------------------------
    const showModal = () => {
      document.body.classList.add("modal-open");
    };

    const hideModal = () => {
      document.body.classList.remove("modal-open");
    };

    // ---------------------------
    // PAGE MOUNT
    // ---------------------------
    onMounted(() => {
      // AUTH CHECK
      if (!localStorage.getItem("authToken")) {
        router.push("/login");
      }

      // GET AMOUNT FROM ROUTER
      if (!router.currentRoute.value.query.goodsId) {
        router.push("/mine");
      } else {
        userammount.value = router.currentRoute.value.query.goodsId;
      }

      // FETCH UPI
      getupiFun();

      // ---------------------------
      // NOTICE TIMER 20s
      // ---------------------------
      noticeInterval = setInterval(() => {
        if (countDown1.value > 0) {
          countDown1.value--;
        }
        if (countDown1.value === 0) {
          clearInterval(noticeInterval);
        }
      }, 1000);

      // ---------------------------
      // MAIN TIMER 30 min
      // ---------------------------
      mainTimer = setInterval(() => {
        if (countDown.value <= 0) {
          clearInterval(mainTimer);
          router.push("/mine");
        } else {
          countDown.value--;
          countDownMinute.value = Math.floor(countDown.value / 60);
          countDownSecond.value = String(countDown.value % 60).padStart(2, "0");
        }
      }, 1000);
    });

    // ---------------------------
    // CLEANUP ON PAGE LEAVE
    // ---------------------------
    onBeforeUnmount(() => {
      clearInterval(noticeInterval);
      clearInterval(mainTimer);
    });

    return {
      router,
      userammount,
      UPIID,
      Qrcode,
      onCopy,
      onSubmit,
      saveQrCode,
      isErrorShow,
      errorMessage,
      setErrorMessage,
      countDownMinute,
      countDownSecond,
      isNoticeModalVisible,
      countDown1,
      showModal,
      hideModal,
    };
  },
};
</script>


<style scoped>
/* Main page container */

.wallet-message {
  width: 92%;
  margin: 10px auto;
  background: #f1fff3;
  color: #008000;
  padding: 12px;
  border-radius: 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

.wallet-message span {
  margin-right: 8px;
}

.v2_71 {
  width: 100%;
  min-height: 100vh;
  background: #f4f4f4;
  padding-bottom: 40px;
  font-family: Arial, sans-serif;
}

/* Top header */
.v2_137 {
  width: 100%;
  height: 72px;
  padding: 0;
  background: linear-gradient(135deg,#006b16,#00a52a);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upi-brand {
  width: 92%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upi-brand img {
  width: 80px;
  height: 40px;
  object-fit: contain;
}

.upi-divider {
  width: 1px;
  height: 35px;
  background: rgba(255,255,255,0.5);
  margin: 0 14px;
}

.upi-text {
  text-align: left;
  font-size: 14px;
  font-weight: 700;
}

.upi-text span {
  display: block;
  margin-top: 4px;
  font-size: 10px;
  font-weight: 400;
}

.v2_139 {
  display: block;
  font-size: 18px;
  font-weight: bold;
}

.v2_140 {
  display: block;
  font-size: 22px;
  font-weight: bold;
}

.v2_141 {
  display: block;
  font-size: 10px;
  opacity: 0.8;
  letter-spacing: 1px;
  padding : 23px 0 0 0;
}

/* Main white card */
.v2_74 {
  width: 92%;
  margin: 12px auto;
  background: #fff;
  padding: 14px;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}

/* Heading: Use Mobile Scan code */
.v2_131 {
  text-align: center;
  margin-bottom: 2px;
}
.v2_132 {
  font-size: 14px;
  font-weight: 600;
}

/* Amount */
.v2_133 {
  text-align: center;
}
.v2_134 {
  font-size: 30px;
  font-weight: 700;
  color: #008000;
}

/* Payment ID */
.v2_135 {
  text-align: center;
  margin-bottom: 4px;
}
.v2_136 {
  color: #888;
  font-size: 12px;
}

/* QR and instructions box */
.v2_122 {
  margin-top: 4px;
  padding: 2px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
}

.v2_125,
.v2_124 {
  font-size: 12px;
  color: #555;
  display: block;
  margin-top: 4px;
}

/* QR image placeholder */
.v2_130 {
  width: 170px;
  height: 200px;
  margin: 2px auto;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Save QR button */
.v2_126 {
  text-align: center;
  margin-top: 0px;
}

.v2_127 {
  display: inline-flex;
  align-items: center;
  background: #eaf7ea;
  padding: 4px 12px;
  border-radius: 18px;
  cursor: pointer;
}
.v2_128 {
  width: 14px;
  height: 14px;
  background: #008000;
  border-radius: 50%;
  margin-right: 6px;
}
.v2_129 {
  font-size: 12px;
  color: #008000;
  font-weight: 600;
}

/* Notice box */
.v2_77 {
  background: #f4fff5;
  padding: 14px;
  border: 1px solid #d5efd8;
  border-radius: 14px;
  margin-top: 16px;
}

.v2_82 {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #008000;
  margin-bottom: 8px;
}

.v2_80,
.v2_81 {
  font-size: 13px;
  line-height: 1.5;
  color: #444;
  display: block;
  margin-top: 4px;
}

/* UPI section */

.qr-info {
  margin: 8px 0;
  background: #f7f7f7;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 11px;
  color: #333;
  line-height: 1.3;
}

.qr-check {
  width: 22px;
  height: 22px;
  background: #008000;
  color: #fff;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.v2_92 {
  margin-top: 14px;
  padding: 0 2px;
}

.v2_109 {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
}

.v2_103 {
  background: #f4fff5;
  border: 1px solid #d5efd8;
  border-radius: 12px;
  padding: 10px 12px;
  min-height: 46px;
  display: flex;
  align-items: center;
  position: relative;
  margin: 8px 0;
}


.upi-logo {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.upi-logo img {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

.v2_108 {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
  color: #222;
  padding-right: 70px;
}

.v2_105 {
  position: absolute;
  right: 10px;
  background: #008000;
  color: #fff;
  padding: 6px 14px;
  border-radius: 10px;
  font-size: 12px;
  cursor: pointer;
}

.v2_101,
.v2_95,
.v2_102 {
  font-size: 12px;
  color: #555;
  font-weight: 600;
  text-align: center;
}

/* Payment app icons placeholders */
.v2_97,
.v2_98,
.v2_99,
.v2_100 {
  width: 58px;
  height: 70px;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 4px;
}

.v2_97 span,
.v2_98 span,
.v2_99 span,
.v2_100 span {
  font-size: 9px;
  color: #555;
  margin-top: 2px;
  font-weight: 600;
}

/* UTR section */

.upi-info-text {
  background: #f7f7f7;
  border-radius: 10px;
  padding: 8px 12px;
  margin: 10px 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

.v2_91 {
  display: block;
  font-weight: 700;
  font-size: 15px;
  margin-top: 14px;
}

.v2_90 {
  display: block;
  font-size: 11px;
  color: #008000;
  margin-bottom: 8px;
}

.v2_87 {
  background: #f7f7f7;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid #eeeeee;
}

.v2_89 {
  font-size: 14px;
  color: #666;
}

/* Submit button */
.v2_83 {
  margin-top: 20px;
}

.v2_85 {
  background: #008000;
  padding: 12px;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
}

.v2_86 {
  font-size: 15px;
  font-weight: bold;
  color: #fff;
}

/* Modal fade animation */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}

/* Toast message */
/* .toast-content {
  position: fixed;
  left: 50%;
  bottom: 50px;
  transform: translateX(-50%);
  background: #333;
  padding: 12px 20px;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  z-index: 999;
} */

 .pays ul {
  list-style: none;
  padding: 0;
}

.inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
}

.inner div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.inner img {
  width: 40px;
  height: 40px;
}
</style>
